import React from 'react';
import {Box, Chip, Tooltip} from '@mui/material';
import {styled} from '@mui/system';

import {buildHealthIndicatorIcon} from '../../helpers/HealthIndicatorBuilder';
import SessionHealthTooltip from './SessionHealthTooltip';

const StyledBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});

const StyledChip = styled(Chip)(({ isHealthy, chipStyles }) => ({
  ...chipStyles(isHealthy),
}));

export default function SessionHealthDetail({session, options, chipStyles}) {
  const currentHealthIndicatorIcon = buildHealthIndicatorIcon(options.defaultHeathIndicatorChipIcon || session.currentHealthEventType);

  return (
    <StyledBox>
      <Tooltip
        arrow
        title={<SessionHealthTooltip session={session} options={options} />}
        PopperProps={{sx: {'& .MuiTooltip-tooltip': {borderRadius: '2rem', maxWidth: 'none'}}}}
      >
        <StyledChip
          icon={currentHealthIndicatorIcon}
          size="small"
          isHealthy={session.isHealthy}
          chipStyles={chipStyles}
        />
      </Tooltip>
    </StyledBox>
  );
}
